import {ReactNode, useMemo} from 'react';
import {view} from '@sail/ui/deprecated';
import {
  RequestACallConfirmation as RACConfirmation,
  useTheme,
} from '@stripe-internal/conversations-ui';
import {useRacVerificationCodes} from './useRacVerificationCodes';
import {renderRequestACallError} from './renderRequestACallError';

type Props = {
  name: string;
  phoneNumber: string;
  waitTime?: ReactNode;
};

export const RequestACallConfirmation = ({
  name,
  phoneNumber,
  waitTime,
}: Props) => {
  const theme = useTheme();
  const {loading, clientError, serverError, verificationCodes} =
    useRacVerificationCodes();

  const error = useMemo(
    () =>
      renderRequestACallError({
        theme,
        clientError,
        serverError,
      }),
    [theme, clientError, serverError],
  );

  return (
    <view.div css={{padding: 'medium'}}>
      <RACConfirmation
        name={name}
        phoneNumber={phoneNumber}
        waitTime={waitTime}
        verificationCodesLoading={loading}
        verificationCodesError={error}
        verificationCodes={verificationCodes}
      />
    </view.div>
  );
};
